<template>
    <!--腾讯验证码-->
    <div v-show="showModalCaptcha" class="modal"></div>
</template>

<script>
import ajax from '@/api/ajax'
export default {
    name: 'TencentCaptcha',
    data() {
        return {
            showModalCaptcha: false,
            newCapIns: null,
            fetchData: [] // 请求的运单数据
        }
    },
    // 销毁验证码
    destroyed() {
        if (_webconfig.useTencentCaptcha == true && typeof capDestroy === 'function') {
            window.capDestroy()
        }
    },
    methods: {
        // 通过url获得腾讯js
        async getCaptcha(func, fetchData = []) {
            this.validationCallback = func
            this.fetchData = fetchData
            const windowConfigRes = await ajax.getWindowConfig()
            const { switches = { openNewSlider: true } } = windowConfigRes
            if (switches.openNewSlider) {
                try {
                    if (window.capInit) {
                        // 否则用老的，不弹提示框
                        this.openOldSlider()
                    } else if (this.newCapIns) {
                        // 新版本滑块实例存在，直接用新的
                        this.newCapIns.show()
                    } else {
                        // 新版本实例不存在，且window.capInit不存在，说明新、旧两个脚本都没有加载过，直接加载新版本的sdk
                        const script = document.createElement('script')
                        script.type = 'text/javascript'
                        script.src = 'https://turing.captcha.qcloud.com/TCaptcha.js'
                        document.body.appendChild(script)
                        script.onload = () => {
                            this.newCapIns = new window.TencentCaptcha('2037219860', this.routesForNoLoginNew, {
                                userLanguage: 'zh-cn'
                            })
                            this.newCapIns.show() // 显示验证码
                        }
                        script.onerror = () => {
                            this.openOldSliderDialog('获取腾讯滑块js错误')
                        }
                    }
                } catch (error) {
                    this.openOldSliderDialog(error)
                }
            } else {
                this.openOldSlider()
            }
        },
        routesForNoLoginNew(retJson) {
            const { errorCode = 0, ret } = retJson
            if (errorCode) {
                this.newCapIns = null
                this.openOldSliderDialog(retJson.errorCode)
            } else if (ret === 0) {
                this.validationCallback(retJson, true, this.fetchData)
            }
        },
        async openOldSliderDialog(code = '404') {
            const windowConfigRes = await ajax.getWindowConfig()
            const { switches = { disableMobileOldSlider: true } } = windowConfigRes
            const tempStr = switches.disableMobileOldSlider ? '' : '点击确认后，将调用旧版腾讯滑块验证码。'
            this.$confirm(`调用新版腾讯滑块验证码异常，errorCode=${code}。${tempStr}对你造成的不变敬请谅解，感谢你的理解和支持。`).then(() => {
                !switches.disableMobileOldSlider && this.openOldSlider()
            })
        },
        openOldSlider() {
            if (typeof capDestroy !== 'function') {
                this.$loading('')
                ajax.getTencentUrl({
                    params: {
                        device: 'mobile'
                    }
                })
                    .then(response => {
                        if (response.data) {
                            const script = document.createElement('script')
                            script.src = response.data.result
                            script.type = 'text/javascript'
                            document.body.appendChild(script)
                            script.onload = () => {
                                this.initCaptcha()
                            }
                            script.onerror = () => {
                                this.$toast('查询异常，请稍后再试')
                            }
                        } else {
                            this.$toast('查询异常，请稍后再试')
                        }
                    })
                    .finally(() => {
                        this.$loading()
                    })
            } else {
                this.initCaptcha()
            }
        },
        // 初始化腾讯验证码
        initCaptcha() {
            window.capDestroy()
            this.showModalCaptcha = true
            window.capInit(document.getElementById('TCaptcha'), {
                callback: retJson => {
                    if (retJson.ret === 0) {
                        this.validationCallback(retJson, false, this.fetchData)
                    }
                },
                showHeader: true,
                themeColor: '000000',
                type: 'popup',
                pos: 'fixed',
                end: () => {
                    this.showModalCaptcha = false
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.modal {
    position: fixed;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: #000;
    opacity: 0.5;
    z-index: 998;
}
</style>



// WEBPACK FOOTER //
// src/components/validation/tencent-captcha.vue